import React from 'react';

export default function LoadingSpinner({ size = 32, color = '#1e40af', label }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
          animation: 'spin 0.8s linear infinite',
        }}
      >
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        <circle cx="12" cy="12" r="10" stroke={color} strokeOpacity="0.2" />
        <path d="M12 2 a10 10 0 0 1 10 10" stroke={color} />
      </svg>
      {label && <span style={{ fontSize: '0.9rem', color: '#64748b' }}>{label}</span>}
    </div>
  );
}
